module.exports = __webpack_public_path__ + "static/media/placas (6).3b760d08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas/placas (6).jpg
// module id = 356
// module chunks = 0